import { ComposerPrimitive } from '@assistant-ui/react';
import { useCallback, useEffect, useState } from 'react';

import { AttachmentGallery } from 'components/agent/attachment-gallery';
import { ComposerAttachment } from 'components/composer/composer-attachment';

const ComposerAttachments = ({ disabled = false }) => {
	const [attachments, setAttachments] = useState<any[]>([]);
	const [selection, setSelection] = useState<any>({});
	const [open, setOpen] = useState(false);

	// Hooks
	useEffect(() => {
		if (!open || !selection.id) return;
		if (attachments.some(attachment => attachment.id === selection.id)) return;
		setOpen(false);
		setSelection({});
	}, [attachments, open, selection]);

	// Actions
	const onRegister = useCallback(data => {
		setAttachments(current => {
			const index = current.findIndex(attachment => attachment.id === data.id);
			if (index === -1) return [...current, data];

			const next = [...current];
			next[index] = data;
			return next;
		});
	}, []);

	const onUnregister = useCallback(id => {
		setAttachments(current => current.filter(attachment => attachment.id !== id));
	}, []);

	const onView = useCallback(attachment => {
		setSelection(attachment);
		setOpen(true);
	}, []);

	if (disabled) return null;

	return (
		<>
			<div className='flex-start flex-wrap gap-2 pb-2 empty:hidden'>
				<ComposerPrimitive.Attachments>
					{({ attachment }) => (
						<ComposerAttachment
							attachment={attachment}
							onImageRegister={onRegister}
							onImageUnregister={onUnregister}
							onView={onView}
						/>
					)}
				</ComposerPrimitive.Attachments>
			</div>
			<AttachmentGallery attachments={attachments} open={open} selection={selection} setOpen={setOpen} />
		</>
	);
};

export { ComposerAttachments };
